import { api } from 'apis/restaurant-api/api';

import { CreditAcquisition } from './types';

export const getCreditAcquisitions = async (venueId: string, purchaseIds: string[]): Promise<CreditAcquisition[]> => {
  const config = {
    params: {
      purchase_ids: purchaseIds.join(','),
    },
  };

  const { data } = await api.get<{ results: CreditAcquisition[] }>(
    `/v1/merchant-admin/venues/${venueId}/credit_acquisitions`,
    config,
  );
  return data.results;
};

export const sendCredits = (venueId: string, purchaseId: string): Promise<void> => {
  return api.post(`/v1/merchant-admin/venues/${venueId}/purchases/${purchaseId}/send_credits`);
};
